import {IHttpService} from "angular";

export class HolidayService {

    public static id = "holidayService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async get(market: string): Promise<Array<Date>> {
        const response = await this.$http.get<Array<string>>(`/tradefloor/api/market/${market}/holidays`);
        const holidays = response.data!.map(d => new Date(d));

        return holidays;
    }
}
